import AlertModalAction from "../../redux/actions/AlertModalAction";

const logout = (idle = false) => {
  const deviceId = sessionStorage.getItem("deviceId");

  const callback = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("accessToken");

    if (idle) {
      AlertModalAction.open(
        "You have been logged out due to inactivity, please log in again to continue using Guardian Mobile.",
        "Session Timeout",
        () => {
          window.location = "/?deviceid=" + deviceId;
        },
      );
    } else {
      window.location = "/?deviceid=" + deviceId;
    }
  };
};

export default logout;
